export default "__VITE_ASSET__Cbk$8YuL__"